import { getServiceWorkerContainer } from './serviceWorkerContainer';

/** Waits for every operation, also after one failed, then rejects with the first failure. */
async function settleAll(operations: Promise<unknown>[]): Promise<void> {
  const failure = (await Promise.allSettled(operations)).find((result) => result.status === 'rejected');
  if (failure) {
    throw failure.reason;
  }
}

/** Unregisters every worker of the page. */
export async function unregisterServiceWorkers(): Promise<void> {
  const registrations = (await getServiceWorkerContainer()?.getRegistrations()) ?? [];
  await settleAll(registrations.map((registration) => registration.unregister()));
}

/** Deletes every cache of Cache Storage; `onDelete` is told each cache name. */
export async function deleteAllCaches(onDelete?: (cacheName: string) => void): Promise<void> {
  if (typeof caches === 'undefined') {
    return;
  }
  const cacheNames = await caches.keys();
  await settleAll(
    cacheNames.map((cacheName) => {
      onDelete?.(cacheName);
      return caches.delete(cacheName);
    })
  );
}
